import script from "./ElMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./ElMenu.vue?vue&type=script&setup=true&lang=js"

import "./ElMenu.vue?vue&type=style&index=0&id=55f3d366&scoped=true&lang=scss"
import "./ElMenu.vue?vue&type=style&index=1&id=55f3d366&lang=scss"

import exportComponent from "D:\\phpstudy_pro\\WWW\\qianpaiyun\\v2_2\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-55f3d366"]])

export default __exports__